exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category-dot[data-v-57eefb0f] {\n    height: 8px;\n    width: 8px;\n    border-radius: 50%;\n    display: inline-block;\n}\n", ""]);

// exports
